import React, { useEffect, useState } from "react";
import client from "../../../../utils/prismicHelpers";
import * as queries from "../../../../utils/prismicQueries";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./robotClng.css";
import CallParticipation from "../CallParticipation/CallParticipation";
import ProblemDescript from "../ProblemDescipt/ProblemDescript";
import ProposalSubmit from "../ProposalSubmit/ProposalSubmit";
import Guidelines from "../Guidelines/Guidelines";
import FullMenu from "../../../../main/components/fullmenu";
import { useNavigate } from "react-router";
import LatestUpdate from "../LatestUpdate/LatestUpdate";
import AcademicBackBtn from "../../AcademicBackBtn";
import PhotoGallery from "../PhotoGallery/PhotoGallery";

const RoboChallenge = () => {
  const navigate = useNavigate();
  const [roboInfo, setRoboInfo] = useState(null);
  const [filteredTab, setFilteredTab] = useState([]);

  useEffect(() => {
    client
      .query({
        query: queries.roboticChallange,
      })
      .then((response) => {
        const roboDoc = response.data.allRobotic_challanges.edges[0].node;
        setRoboInfo(roboDoc);
        setFilteredTab(roboDoc?.nav_tab?.filter(tab => tab.hide === false))
        window.scrollTo(0, 0);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <section
        style={{ background: `url(${roboInfo?.section_bg?.url})` }}
        className=" section-common-info"
      >
        <div className="container">
          <AcademicBackBtn />
          <h3 className="subtitle pt-0 pb-1">{roboInfo?.title[0]?.text}</h3>
          <p className="pt-2 body-text">
            {roboInfo?.description[0]?.text}
            <br />{" "}
          </p>



          <div className="robo-nav-container">
            <div className="nav pt-2 pb-4 nav-tabs" id="nav-tab" role="tablist">
              {filteredTab?.map((item, index) =>
                <button
                  key={index + 1}
                  className={`nav-link border-0 ${index === 0 && "active"}  primary-text`}
                  id={`${item.id}-tab`}
                  data-bs-toggle="tab"
                  data-bs-target={`#${item.id}`}
                  type="button"
                  role="tab"
                  aria-controls={item.id}
                  aria-selected={index === 0 ? "true" : "false"}
                >
                  {item?.title1}
                </button>)}
            
            </div>

            <div className="tab-content pt-2" id="nav-tabContent">
              <div
                className={`tab-pane fade ${filteredTab[0]?.id == "call-paricipate" && "show active"}  `}
                id="call-paricipate"
                role="tabpanel"
                aria-labelledby="call-paricipate-tab"
              >
                <CallParticipation></CallParticipation>
              </div>
              <div
                className={`tab-pane fade ${filteredTab[0]?.id == "problem-des" && "show active"}  `}
                id="problem-des"
                role="tabpanel"
                aria-labelledby="problem-des-tab"
              >
                <ProblemDescript></ProblemDescript>
              </div>
              <div
                className={`tab-pane fade ${filteredTab[0]?.id == "propose-sumbit" && "show active"}  `}
                id="propose-sumbit"
                role="tabpanel"
                aria-labelledby="propose-sumbit-tab"
              >
                <ProposalSubmit></ProposalSubmit>
              </div>
              <div
                className={`tab-pane fade ${filteredTab[0]?.id == "guidelines" && "show active"}  `}
                id="guidelines"
                role="tabpanel"
                aria-labelledby="guideline-tab"
              >
                <Guidelines></Guidelines>
              </div>

              <div
                className={`tab-pane fade ${filteredTab[0]?.id == "latest" && "show active"}  `}
                id="latest"
                role="tabpanel"
                aria-labelledby="latest-tab"
              >
                <LatestUpdate />
              </div>
              <div
                className={`tab-pane fade ${filteredTab[0]?.id == "gallery" && "show active"}  `}
                id="gallery"
                role="tabpanel"
                aria-labelledby="gallery-tab"
              >
                <PhotoGallery />
              </div>

            </div>





          </div>

        </div>
      </section>
      <FullMenu />
    </>
  );
};

export default RoboChallenge;
